@for (city of cities(); track city) {
  <div class="mb-8" *transloco="let t; prefix: 'wizard.company'">
    <p-panel [toggleable]="true" [style]="{'border': 'none'}">
      <ng-template #header>
        <div class="flex items-end gap-2">
          <span class="font-bold">
            {{ countryService.getCountryNameByCode(city.countryCode) + ', ' + city.name }}
          </span>
          <span class="text-sm text-muted-color">
            {{ offices()[city.uuid].length }}
            {{ offices()[city.uuid].length === 1 ? t('office') : t('offices') }}
          </span>
        </div>
      </ng-template>
      <div class="p-2">
        @for (office of offices()[city.uuid]; track $index) {
          <div class="flex gap-5 pt-6">
            <div class="flex-1">
              <div class="flex flex-col gap-2">
                <label [for]="'name-' + city.uuid + '-' + $index">
                  {{ t('officeNameLabel', {number: $index + 1}) }}
                </label>
                <input
                  #nameInput
                  pInputText
                  [id]="'name-' + city.uuid + '-' + $index"
                  [attr.data-testid]="
                    'office-name-' + city.countryCode + '-' + city.name + '-' + $index
                  "
                  type="text"
                  placeholder="{{ t('enterOfficeNamePlaceholder') }}"
                  class="w-full"
                  [value]="office.name"
                  (input)="onOfficeNameChange(city.uuid, $index, nameInput.value)"
                  (blur)="onOfficeNameBlur(city.uuid, $index, nameInput.value)"
                  required
                />
                @if (shouldShowOfficeNameError(city.uuid, $index)) {
                  <p-message severity="error" variant="simple" size="small">
                    {{ t('officeNameRequired') }}
                  </p-message>
                }
              </div>
            </div>
            <div class="flex-1">
              <div class="flex flex-col gap-2">
                <label [for]="'address-' + city.uuid + '-' + $index">
                  {{ t('officeAddressLabel', {number: $index + 1}) }}
                </label>
                <div class="flex gap-5 items-center">
                  <input
                    #addressInput
                    pInputText
                    [id]="'address-' + city.uuid + '-' + $index"
                    [attr.data-testid]="
                      'office-address-' + city.countryCode + '-' + city.name + '-' + $index
                    "
                    type="text"
                    placeholder="{{ t('enterOfficeAddressPlaceholder') }}"
                    class="w-full"
                    [value]="office.address"
                    [ngClass]="{'p-invalid': shouldShowOfficeAddressError(city.uuid, $index)}"
                    (input)="onOfficeAddressChange(city.uuid, $index, addressInput.value)"
                    (blur)="onOfficeAddressBlur(city.uuid, $index, addressInput.value)"
                    required
                  />
                  @if ($count > 1) {
                    <button
                      type="button"
                      [attr.data-testid]="'delete-office-' + city.countryCode + '-' + $index"
                      class="text-gray-400 hover:text-gray-300 transition-colors p-2 self-auto"
                      (click)="removeOffice(city.uuid, $index)"
                      [disabled]="!isOfficeDeletable(city.uuid, $index)"
                      [pTooltip]="
                        !isOfficeDeletable(city.uuid, $index)
                          ? t('officeCannotBeDeleted')
                          : undefined
                      "
                    >
                      <i class="pi pi-trash"></i>
                    </button>
                  }
                </div>
              </div>
              @if (shouldShowOfficeAddressError(city.uuid, $index)) {
                <p-message severity="error" variant="simple" size="small">
                  {{ t('officeAddressRequired') }}
                </p-message>
              }
            </div>
          </div>
        }
        <button
          class="flex items-center gap-2 text-gray-400 hover:text-gray-300 transition-colors mt-6"
          (click)="addOffice(city.uuid)"
          [attr.data-testid]="'add-office-' + city.countryCode + '-' + city.name"
        >
          <i class="pi pi-plus-circle"></i>
          <span>{{ t('addOffice') }}</span>
        </button>
      </div>
    </p-panel>
  </div>
}
